import { childEndpoints } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { queryClient } from "@/lib/queryClient";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentChild(
  childId: number | null | string | undefined
) {
  const query = useQuery({
    queryKey: ["get-child", childId],
    enabled: Boolean(childId),
    queryFn: async () => {
      const res = await axiosInstance.get(`${childEndpoints}/${childId}`);
      return res.data.child;
    },
  });

  return {
    child: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
export const refetchCurrentChild = async () => {
  await queryClient.invalidateQueries({ queryKey: ["get-child"] });
};
